
// FIX: Corrected import path for models.
import { Customer } from '../models/index';

const now = new Date().toISOString();
const mockStoreId = 'mock-store-id-12345';

// FIX: Aligned mock data with the Customer interface.
export const MOCK_CUSTOMERS: Customer[] = [
  // FIX: Added missing 'storeId' property.
  { id: 'CUST001', storeId: mockStoreId, fullName: 'John Doe', citizenId: '1-1020-30405-67-8', birthDate: '1990-05-15', phone: '081-234-5678', address: '88/1 Sukhumvit Rd, Bangkok 10110', pointsBalance: 150, tierLevel: 'Silver', createdAt: now },
  // FIX: Added missing 'storeId' property.
  { id: 'CUST002', storeId: mockStoreId, fullName: 'Jane Smith', citizenId: 'A12345678', birthDate: '1985-11-20', phone: '089-876-5432', address: '555 Silom Rd, Bang Rak, Bangkok 10500', pointsBalance: 50, tierLevel: 'Bronze', createdAt: now },
  // FIX: Added missing 'storeId' property.
  { id: 'CUST003', storeId: mockStoreId, fullName: 'Alice Johnson', citizenId: '9-8765-43210-98-7', birthDate: '2008-01-30', phone: '086-555-1212', address: '99 Rama 9 Rd, Huai Khwang, Bangkok 10310', pointsBalance: 0, tierLevel: 'Bronze', createdAt: now }, // Underage example
  // FIX: Added missing 'storeId' property.
  { id: 'CUST004', storeId: mockStoreId, fullName: 'สมชาย เข็มกลัด', citizenId: '1-2345-67890-12-3', birthDate: '1976-03-10', phone: '088-888-9999', address: '123/4 หมู่ 5 ต.บางโฉลง อ.บางพลี จ.สมุทรปราการ 10540', pointsBalance: 1250, tierLevel: 'Gold', createdAt: now },
];
